import React from 'react'
import Link from 'gatsby-link'

import Nav from '../Nav'
import './index.css'

const Header = () => (
  <header id="app-header">
    <section>
      <Link to="/" className={'nav-home'}>Johnny Metrics</Link>
      <Nav />
    </section>
  </header>
)

export default Header



// WEBPACK FOOTER //
// ./src/components/Header/index.js